/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ApiClientConfiguration {
    apiUrl: string;
    apiKey: string = '';
    private authorizationToken: string = null;
    async getAuthorizationToken(): Promise<string> { return this.authorizationToken; };
    setAuthorizationToken(token: string): void { this.authorizationToken = token; };
}

export class ApiClientBase {
    constructor(private configuration: ApiClientConfiguration) { }

    protected async transformOptions(options: any): Promise<any> {
        const token = await this.configuration.getAuthorizationToken();
        if (token != null) {
            options.headers = (options.headers as HttpHeaders).append("authorization", "Bearer " + token);
        } else {
            options.headers = (options.headers as HttpHeaders).append("X-API-Key", this.configuration.apiKey);
        }
        //options = { ...options, transformResponse: (res) => res, responseType: 'json' };
        return options;
    }

    protected getBaseUrl(defultUrl: string) {
        if (this.configuration.apiUrl.endsWith('/')) {
            return this.configuration.apiUrl.slice(0, -1);
        }
        return this.configuration.apiUrl;
    }

    protected transformResult(url: string, res: HttpResponseBase, cb: (res: HttpResponseBase) => Observable<any>): Observable<any> {
      return cb(res);
    }
}

export interface IBuildInfoApiClient {
    /**
     * Returns an assembly build info.
     * @return Success
     */
    headInfo(): Observable<void>;
    /**
     * Returns an assembly build info.
     * @return Success
     */
    getInfo(): Observable<BuildInfoModel>;
}

@Injectable({
    providedIn: 'root'
})
export class BuildInfoApiClient extends ApiClientBase implements IBuildInfoApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns an assembly build info.
     * @return Success
     */
    headInfo(): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("head", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processHeadInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processHeadInfo(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHeadInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns an assembly build info.
     * @return Success
     */
    getInfo(): Observable<BuildInfoModel> {
        let url_ = this.baseUrl + "/api/storefront/v1/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInfo(<any>r));
                } catch (e) {
                    return <Observable<BuildInfoModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BuildInfoModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<BuildInfoModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BuildInfoModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BuildInfoModel>(<any>null);
    }
}

export interface IProcessingPipelinesApiClient {
    /**
     * Returns all processing pipelines relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param search (optional) Search string for partial by processing pipeline name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(skip?: number | null | undefined, take?: number | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProcessingPipelineDto>;
    /**
     * Returns a processing pipeline.
     * @param id Processing pipeline identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<ProcessingPipelineDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProcessingPipelinesApiClient extends ApiClientBase implements IProcessingPipelinesApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all processing pipelines relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param search (optional) Search string for partial by processing pipeline name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(skip?: number | null | undefined, take?: number | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProcessingPipelineDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/processing-pipelines?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProcessingPipelineDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProcessingPipelineDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfProcessingPipelineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProcessingPipelineDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProcessingPipelineDto>(<any>null);
    }

    /**
     * Returns a processing pipeline.
     * @param id Processing pipeline identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<ProcessingPipelineDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/processing-pipelines/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<ProcessingPipelineDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProcessingPipelineDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProcessingPipelineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProcessingPipelineDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProcessingPipelineDto>(<any>null);
    }
}

export interface IProductBundlesApiClient {
    /**
     * Returns all product bundles, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductBundles(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductBundleDto>;
    /**
     * Returns a product bundle by its identifier.
     * @param id Product identifier.
     * @param productBundleVersionId (optional) Product bundle version identifier. Optional
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductBundle(id: number, productBundleVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductBundleDto>;
    /**
     * Returns a product bundle summary by product bundle identifier.
     * @param id Product bundle identifier.
     * @param productBundleVersionId (optional) Product bundle version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(id: number, productBundleVersionId?: number | null | undefined, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto>;
    /**
     * Returns a product bundle personalization workflow description by product bundle identifier.
     * @param id Product bundle identifier.
     * @param productBundleVersionId (optional) Product bundle version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, productBundleVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductBundlesApiClient extends ApiClientBase implements IProductBundlesApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all product bundles, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductBundles(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductBundleDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-bundles?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProductBundles(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProductBundles(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductBundleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductBundleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductBundles(response: HttpResponseBase): Observable<PagedOfProductBundleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductBundleDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductBundleDto>(<any>null);
    }

    /**
     * Returns a product bundle by its identifier.
     * @param id Product identifier.
     * @param productBundleVersionId (optional) Product bundle version identifier. Optional
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductBundle(id: number, productBundleVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductBundleDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-bundles/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productBundleVersionId !== undefined && productBundleVersionId !== null)
            url_ += "productBundleVersionId=" + encodeURIComponent("" + productBundleVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductBundle(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductBundle(<any>r));
                } catch (e) {
                    return <Observable<ProductBundleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductBundleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductBundle(response: HttpResponseBase): Observable<ProductBundleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductBundleDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductBundleDto>(<any>null);
    }

    /**
     * Returns a product bundle summary by product bundle identifier.
     * @param id Product bundle identifier.
     * @param productBundleVersionId (optional) Product bundle version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(id: number, productBundleVersionId?: number | null | undefined, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-bundles/{id}/summary?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productBundleVersionId !== undefined && productBundleVersionId !== null)
            url_ += "productBundleVersionId=" + encodeURIComponent("" + productBundleVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
                } catch (e) {
                    return <Observable<ProductSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSummary(response: HttpResponseBase): Observable<ProductSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductSummaryDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSummaryDto>(<any>null);
    }

    /**
     * Returns a product bundle personalization workflow description by product bundle identifier.
     * @param id Product bundle identifier.
     * @param productBundleVersionId (optional) Product bundle version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, productBundleVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-bundles/{id}/personalization-workflow?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productBundleVersionId !== undefined && productBundleVersionId !== null)
            url_ += "productBundleVersionId=" + encodeURIComponent("" + productBundleVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
                } catch (e) {
                    return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalizationWorkflow(response: HttpResponseBase): Observable<PersonalizationWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PersonalizationWorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalizationWorkflowDto>(<any>null);
    }
}

export interface IProductLinksApiClient {
    /**
     * Returns all product links, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductLinks(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductLinkDto>;
    /**
     * Returns a product link by its identifier.
     * @param id Product identifier.
     * @param productLinkVersionId (optional) Product link version identifier. Optional
     * @param productVersionId (optional) Product version identifier which represents linked product version. Optional
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLink(id: number, productLinkVersionId?: number | null | undefined, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductLinkDto>;
    /**
     * Returns a product link summary by product link identifier.
     * @param id Product link identifier.
     * @param productLinkVersionId (optional) Product link version identifier.
     * @param productVersionId (optional) Product link identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(id: number, productLinkVersionId?: number | null | undefined, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto>;
    /**
     * Returns a product link personalization workflow description by product link identifier.
     * @param id Product link identifier.
     * @param productLinkVersionId (optional) Product link version identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productFilterId (optional) Product filter identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, productLinkVersionId?: number | null | undefined, productVersionId?: number | null | undefined, productFilterId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductLinksApiClient extends ApiClientBase implements IProductLinksApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all product links, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductLinks(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductLinkDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-links?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProductLinks(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProductLinks(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductLinks(response: HttpResponseBase): Observable<PagedOfProductLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductLinkDto>(<any>null);
    }

    /**
     * Returns a product link by its identifier.
     * @param id Product identifier.
     * @param productLinkVersionId (optional) Product link version identifier. Optional
     * @param productVersionId (optional) Product version identifier which represents linked product version. Optional
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLink(id: number, productLinkVersionId?: number | null | undefined, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductLinkDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-links/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productLinkVersionId !== undefined && productLinkVersionId !== null)
            url_ += "productLinkVersionId=" + encodeURIComponent("" + productLinkVersionId) + "&";
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductLink(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductLink(<any>r));
                } catch (e) {
                    return <Observable<ProductLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductLink(response: HttpResponseBase): Observable<ProductLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductLinkDto>(<any>null);
    }

    /**
     * Returns a product link summary by product link identifier.
     * @param id Product link identifier.
     * @param productLinkVersionId (optional) Product link version identifier.
     * @param productVersionId (optional) Product link identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(id: number, productLinkVersionId?: number | null | undefined, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-links/{id}/summary?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productLinkVersionId !== undefined && productLinkVersionId !== null)
            url_ += "productLinkVersionId=" + encodeURIComponent("" + productLinkVersionId) + "&";
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
                } catch (e) {
                    return <Observable<ProductSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSummary(response: HttpResponseBase): Observable<ProductSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductSummaryDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSummaryDto>(<any>null);
    }

    /**
     * Returns a product link personalization workflow description by product link identifier.
     * @param id Product link identifier.
     * @param productLinkVersionId (optional) Product link version identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productFilterId (optional) Product filter identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, productLinkVersionId?: number | null | undefined, productVersionId?: number | null | undefined, productFilterId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-links/{id}/personalization-workflow?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productLinkVersionId !== undefined && productLinkVersionId !== null)
            url_ += "productLinkVersionId=" + encodeURIComponent("" + productLinkVersionId) + "&";
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
                } catch (e) {
                    return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalizationWorkflow(response: HttpResponseBase): Observable<PersonalizationWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PersonalizationWorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalizationWorkflowDto>(<any>null);
    }
}

export interface IProductReferencesApiClient {
    /**
     * Returns all storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductReferenceDto>;
    /**
     * Returns a list of product specifications associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductSpecifications(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductSpecificationDto>;
    /**
     * Returns a list of products associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProducts(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductDto>;
    /**
     * Returns a list of product links associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductLinks(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductLinkDto>;
    /**
     * Returns a list of product bundles associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductBundles(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductBundleDto>;
    /**
     * Returns a storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductReferenceDto>;
    /**
     * Returns a product specification by the storefront product reference.
     * @param reference Product reference - external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSpecification(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductSpecificationDto>;
    /**
     * Returns a product by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProduct(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductDto>;
    /**
     * Returns a product summary by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(reference: string | null, storefrontId: number, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto>;
    /**
     * Returns a product link by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLink(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductLinkDto>;
    /**
     * Returns a product bundle by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductBundle(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductBundleDto>;
    /**
     * Returns a product cost details from ecommerce system.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param sku Product SKU.
     * @param storefrontId Storefront identifier.
     * @param storefrontUserId (optional) Storefront user identifier.
     * @param currencyCode (optional) Product cost currency code.
     * @param quantity (optional) Product quantity.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductCostDetails(reference: string | null, sku: string, storefrontId: number, storefrontUserId?: string | null | undefined, currencyCode?: string | null | undefined, quantity?: number | undefined, tenantId?: number | null | undefined): Observable<ProductCostDetailsDto>;
    /**
     * Returns a product personalization workflow.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId (optional) Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(reference: string | null, storefrontId?: number | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductReferencesApiClient extends ApiClientBase implements IProductReferencesApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductReferenceDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (productSpecificationId !== undefined && productSpecificationId !== null)
            url_ += "productSpecificationId=" + encodeURIComponent("" + productSpecificationId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productBundleId !== undefined && productBundleId !== null)
            url_ += "productBundleId=" + encodeURIComponent("" + productBundleId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductReferenceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductReferenceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfProductReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductReferenceDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductReferenceDto>(<any>null);
    }

    /**
     * Returns a list of product specifications associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductSpecifications(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductSpecificationDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/product-specifications?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (productSpecificationId !== undefined && productSpecificationId !== null)
            url_ += "productSpecificationId=" + encodeURIComponent("" + productSpecificationId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productBundleId !== undefined && productBundleId !== null)
            url_ += "productBundleId=" + encodeURIComponent("" + productBundleId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProductSpecifications(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProductSpecifications(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductSpecificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductSpecificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductSpecifications(response: HttpResponseBase): Observable<PagedOfProductSpecificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductSpecificationDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductSpecificationDto>(<any>null);
    }

    /**
     * Returns a list of products associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProducts(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/products?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (productSpecificationId !== undefined && productSpecificationId !== null)
            url_ += "productSpecificationId=" + encodeURIComponent("" + productSpecificationId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productBundleId !== undefined && productBundleId !== null)
            url_ += "productBundleId=" + encodeURIComponent("" + productBundleId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProducts(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProducts(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProducts(response: HttpResponseBase): Observable<PagedOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductDto>(<any>null);
    }

    /**
     * Returns a list of product links associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductLinks(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductLinkDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/product-links?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (productSpecificationId !== undefined && productSpecificationId !== null)
            url_ += "productSpecificationId=" + encodeURIComponent("" + productSpecificationId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productBundleId !== undefined && productBundleId !== null)
            url_ += "productBundleId=" + encodeURIComponent("" + productBundleId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProductLinks(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProductLinks(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductLinks(response: HttpResponseBase): Observable<PagedOfProductLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductLinkDto>(<any>null);
    }

    /**
     * Returns a list of product bundles associated with storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param productBundleId (optional) Customer's Canvas product bundle filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductBundles(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, productBundleId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductBundleDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/product-bundles?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (productSpecificationId !== undefined && productSpecificationId !== null)
            url_ += "productSpecificationId=" + encodeURIComponent("" + productSpecificationId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productBundleId !== undefined && productBundleId !== null)
            url_ += "productBundleId=" + encodeURIComponent("" + productBundleId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProductBundles(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProductBundles(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductBundleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductBundleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductBundles(response: HttpResponseBase): Observable<PagedOfProductBundleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductBundleDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductBundleDto>(<any>null);
    }

    /**
     * Returns a storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductReferenceDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<ProductReferenceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductReferenceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductReferenceDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductReferenceDto>(<any>null);
    }

    /**
     * Returns a product specification by the storefront product reference.
     * @param reference Product reference - external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSpecification(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductSpecificationDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/product-specification?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductSpecification(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductSpecification(<any>r));
                } catch (e) {
                    return <Observable<ProductSpecificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSpecificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSpecification(response: HttpResponseBase): Observable<ProductSpecificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductSpecificationDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecificationDto>(<any>null);
    }

    /**
     * Returns a product by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProduct(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/product?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProduct(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProduct(<any>r));
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Returns a product summary by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(reference: string | null, storefrontId: number, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/product-summary?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
                } catch (e) {
                    return <Observable<ProductSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSummary(response: HttpResponseBase): Observable<ProductSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductSummaryDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSummaryDto>(<any>null);
    }

    /**
     * Returns a product link by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLink(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductLinkDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/product-link?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductLink(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductLink(<any>r));
                } catch (e) {
                    return <Observable<ProductLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductLink(response: HttpResponseBase): Observable<ProductLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductLinkDto>(<any>null);
    }

    /**
     * Returns a product bundle by storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductBundle(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductBundleDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/product-bundle?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductBundle(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductBundle(<any>r));
                } catch (e) {
                    return <Observable<ProductBundleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductBundleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductBundle(response: HttpResponseBase): Observable<ProductBundleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductBundleDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductBundleDto>(<any>null);
    }

    /**
     * Returns a product cost details from ecommerce system.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param sku Product SKU.
     * @param storefrontId Storefront identifier.
     * @param storefrontUserId (optional) Storefront user identifier.
     * @param currencyCode (optional) Product cost currency code.
     * @param quantity (optional) Product quantity.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductCostDetails(reference: string | null, sku: string, storefrontId: number, storefrontUserId?: string | null | undefined, currencyCode?: string | null | undefined, quantity?: number | undefined, tenantId?: number | null | undefined): Observable<ProductCostDetailsDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/product-cost-details?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (storefrontUserId !== undefined && storefrontUserId !== null)
            url_ += "storefrontUserId=" + encodeURIComponent("" + storefrontUserId) + "&";
        if (currencyCode !== undefined && currencyCode !== null)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductCostDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductCostDetails(<any>r));
                } catch (e) {
                    return <Observable<ProductCostDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductCostDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductCostDetails(response: HttpResponseBase): Observable<ProductCostDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductCostDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductCostDetailsDto>(<any>null);
    }

    /**
     * Returns a product personalization workflow.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId (optional) Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(reference: string | null, storefrontId?: number | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-references/{reference}/personalization-workflow?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === null)
            throw new Error("The parameter 'storefrontId' cannot be null.");
        else if (storefrontId !== undefined)
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
                } catch (e) {
                    return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalizationWorkflow(response: HttpResponseBase): Observable<PersonalizationWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PersonalizationWorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalizationWorkflowDto>(<any>null);
    }
}

export interface IProductsApiClient {
    /**
     * Returns all products, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProducts(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductDto>;
    /**
     * Returns a product by identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProduct(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductDto>;
    /**
     * Returns a product summary by product identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productLinkId (optional) Product link identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(id: number, productVersionId?: number | null | undefined, productLinkId?: number | null | undefined, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto>;
    /**
     * Returns a list of product options.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductOptions(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductOptionDto>;
    /**
     * Returns a list of product options for all products.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductOptions(tenantId?: number | null | undefined): Observable<PagedOfProductOptionDto>;
    /**
     * Returns a list of product links.
     * @param id Product identifier.
     * @param productVersionId (optional) 
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLinks(id: number, productVersionId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductLinkDto>;
    /**
     * Returns a product link.
     * @param id Product identifier.
     * @param productLinkId Product link identifier.
     * @param productVersionId (optional) 
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLink(id: number, productLinkId: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductLinkDto>;
    /**
     * Returns a list of product variants.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariants(id: number, productVersionId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDto>;
    /**
     * Returns a product variant.
     * @param id Product identifier.
     * @param productVariantId Product variant identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariant(id: number, productVariantId: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductVariantDto>;
    /**
     * Returns a list of product variant designs.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param designCustomFields (optional) Custom attributes dictionary filter for designs. For example: {"public":"true","name":"my item"}
     * @param designPath (optional) Path filter for designs. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDesigns(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, designCustomFields?: string | null | undefined, designPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDesignDto>;
    /**
     * Returns a list of product variant mockups.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param mockupCustomFields (optional) Custom attributes dictionary filter for mockups. For example: {"public":"true","name":"my item"}
     * @param mockupPath (optional) Path filter for mockups. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantMockups(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, mockupCustomFields?: string | null | undefined, mockupPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantMockupDto>;
    /**
     * Returns a list of product variant documents.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for document name partial match.
     * @param documentCustomFields (optional) Custom attributes dictionary filter for documents. For example: {"public":"true","name":"my item"}
     * @param documentPath (optional) Path filter for documents. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDocuments(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, documentCustomFields?: string | null | undefined, documentPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDocumentDto>;
    /**
     * Updates product variant resources.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    updateProductVariantResources(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<void>;
    /**
     * Returns a list of all available product tags.
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailableProductTags(search?: string | null | undefined, tenantId?: number | null | undefined): Observable<string[]>;
    /**
     * Returns a product personalization workflow description by product identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productLinkId (optional) Product link identifier.
     * @param productFilterId (optional) Product filter identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, productVersionId?: number | null | undefined, productLinkId?: number | null | undefined, productFilterId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductsApiClient extends ApiClientBase implements IProductsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all products, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProducts(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProducts(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProducts(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProducts(response: HttpResponseBase): Observable<PagedOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductDto>(<any>null);
    }

    /**
     * Returns a product by identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProduct(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProduct(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProduct(<any>r));
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Returns a product summary by product identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productLinkId (optional) Product link identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param sku (optional) Product variant SKU.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductSummary(id: number, productVersionId?: number | null | undefined, productLinkId?: number | null | undefined, productVariantId?: number | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<ProductSummaryDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/summary?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductSummary(<any>r));
                } catch (e) {
                    return <Observable<ProductSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSummary(response: HttpResponseBase): Observable<ProductSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductSummaryDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSummaryDto>(<any>null);
    }

    /**
     * Returns a list of product options.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductOptions(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductOptionDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/options?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductOptions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductOptions(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductOptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductOptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductOptions(response: HttpResponseBase): Observable<PagedOfProductOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductOptionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductOptionDto>(<any>null);
    }

    /**
     * Returns a list of product options for all products.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProductOptions(tenantId?: number | null | undefined): Observable<PagedOfProductOptionDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/options?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProductOptions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProductOptions(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductOptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductOptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductOptions(response: HttpResponseBase): Observable<PagedOfProductOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductOptionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductOptionDto>(<any>null);
    }

    /**
     * Returns a list of product links.
     * @param id Product identifier.
     * @param productVersionId (optional) 
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLinks(id: number, productVersionId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductLinkDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/links?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductLinks(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductLinks(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductLinks(response: HttpResponseBase): Observable<PagedOfProductLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductLinkDto>(<any>null);
    }

    /**
     * Returns a product link.
     * @param id Product identifier.
     * @param productLinkId Product link identifier.
     * @param productVersionId (optional) 
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductLink(id: number, productLinkId: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductLinkDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/links/{productLinkId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productLinkId === undefined || productLinkId === null)
            throw new Error("The parameter 'productLinkId' must be defined.");
        url_ = url_.replace("{productLinkId}", encodeURIComponent("" + productLinkId));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductLink(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductLink(<any>r));
                } catch (e) {
                    return <Observable<ProductLinkDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductLinkDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductLink(response: HttpResponseBase): Observable<ProductLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductLinkDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductLinkDto>(<any>null);
    }

    /**
     * Returns a list of product variants.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariants(id: number, productVersionId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/variants?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariants(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariants(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariants(response: HttpResponseBase): Observable<PagedOfProductVariantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantDto>(<any>null);
    }

    /**
     * Returns a product variant.
     * @param id Product identifier.
     * @param productVariantId Product variant identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariant(id: number, productVariantId: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductVariantDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/variants/{productVariantId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVariantId === undefined || productVariantId === null)
            throw new Error("The parameter 'productVariantId' must be defined.");
        url_ = url_.replace("{productVariantId}", encodeURIComponent("" + productVariantId));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariant(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariant(<any>r));
                } catch (e) {
                    return <Observable<ProductVariantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductVariantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariant(response: HttpResponseBase): Observable<ProductVariantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductVariantDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductVariantDto>(<any>null);
    }

    /**
     * Returns a list of product variant designs.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param designCustomFields (optional) Custom attributes dictionary filter for designs. For example: {"public":"true","name":"my item"}
     * @param designPath (optional) Path filter for designs. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDesigns(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, designCustomFields?: string | null | undefined, designPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDesignDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/variant-designs?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (designCustomFields !== undefined && designCustomFields !== null)
            url_ += "designCustomFields=" + encodeURIComponent("" + designCustomFields) + "&";
        if (designPath !== undefined && designPath !== null)
            url_ += "designPath=" + encodeURIComponent("" + designPath) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariantDesigns(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariantDesigns(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantDesignDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantDesignDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariantDesigns(response: HttpResponseBase): Observable<PagedOfProductVariantDesignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantDesignDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantDesignDto>(<any>null);
    }

    /**
     * Returns a list of product variant mockups.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param mockupCustomFields (optional) Custom attributes dictionary filter for mockups. For example: {"public":"true","name":"my item"}
     * @param mockupPath (optional) Path filter for mockups. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantMockups(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, mockupCustomFields?: string | null | undefined, mockupPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantMockupDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/variant-mockups?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (mockupCustomFields !== undefined && mockupCustomFields !== null)
            url_ += "mockupCustomFields=" + encodeURIComponent("" + mockupCustomFields) + "&";
        if (mockupPath !== undefined && mockupPath !== null)
            url_ += "mockupPath=" + encodeURIComponent("" + mockupPath) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariantMockups(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariantMockups(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantMockupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantMockupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariantMockups(response: HttpResponseBase): Observable<PagedOfProductVariantMockupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantMockupDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantMockupDto>(<any>null);
    }

    /**
     * Returns a list of product variant documents.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for document name partial match.
     * @param documentCustomFields (optional) Custom attributes dictionary filter for documents. For example: {"public":"true","name":"my item"}
     * @param documentPath (optional) Path filter for documents. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDocuments(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, documentCustomFields?: string | null | undefined, documentPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDocumentDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/variant-documents?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (documentCustomFields !== undefined && documentCustomFields !== null)
            url_ += "documentCustomFields=" + encodeURIComponent("" + documentCustomFields) + "&";
        if (documentPath !== undefined && documentPath !== null)
            url_ += "documentPath=" + encodeURIComponent("" + documentPath) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariantDocuments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariantDocuments(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariantDocuments(response: HttpResponseBase): Observable<PagedOfProductVariantDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantDocumentDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantDocumentDto>(<any>null);
    }

    /**
     * Updates product variant resources.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    updateProductVariantResources(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/update-variant-resources?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateProductVariantResources(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateProductVariantResources(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProductVariantResources(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns a list of all available product tags.
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailableProductTags(search?: string | null | undefined, tenantId?: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/available-tags?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAvailableProductTags(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAvailableProductTags(<any>r));
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableProductTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * Returns a product personalization workflow description by product identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productLinkId (optional) Product link identifier.
     * @param productFilterId (optional) Product filter identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, productVersionId?: number | null | undefined, productLinkId?: number | null | undefined, productFilterId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/products/{id}/personalization-workflow?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
                } catch (e) {
                    return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalizationWorkflow(response: HttpResponseBase): Observable<PersonalizationWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PersonalizationWorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalizationWorkflowDto>(<any>null);
    }
}

export interface IProductSpecificationsApiClient {
    /**
     * Returns all product specifications, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductSpecificationDto>;
    /**
     * Returns a product specification by identifier.
     * @param id Product specification identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<ProductSpecificationDto>;
    /**
     * Returns a product personalization workflow description by product specification identifier.
     * @param id Product specification identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductSpecificationsApiClient extends ApiClientBase implements IProductSpecificationsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all product specifications, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductSpecificationDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-specifications?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductSpecificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductSpecificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfProductSpecificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductSpecificationDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductSpecificationDto>(<any>null);
    }

    /**
     * Returns a product specification by identifier.
     * @param id Product specification identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<ProductSpecificationDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-specifications/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<ProductSpecificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductSpecificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductSpecificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductSpecificationDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSpecificationDto>(<any>null);
    }

    /**
     * Returns a product personalization workflow description by product specification identifier.
     * @param id Product specification identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPersonalizationWorkflow(id: number, tenantId?: number | null | undefined): Observable<PersonalizationWorkflowDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/product-specifications/{id}/personalization-workflow?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPersonalizationWorkflow(<any>r));
                } catch (e) {
                    return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonalizationWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonalizationWorkflow(response: HttpResponseBase): Observable<PersonalizationWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PersonalizationWorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonalizationWorkflowDto>(<any>null);
    }
}

export interface IProjectsApiClient {
    /**
     * Returns all projects, relevant to the specified query parameters.
     * @param ownerId (optional) Project owner (storefront user id) filter.
     * @param productReference (optional) Product reference filter.
     * @param status (optional) Project status filter.
     * @param datePeriod (optional) Project date period filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param orderId (optional) Identifier of corresponding order.
     * @param processingStatus (optional) Project processing status filter.
     * @param includeObsolete (optional) Indicates if obsolete projects prepared to be removed should be included to result.
     * @param storefrontId (optional) Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(ownerId?: string | null | undefined, productReference?: string | null | undefined, status?: number | null | undefined, datePeriod?: DatePeriod | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, orderId?: string | null | undefined, processingStatus?: ProjectProcessingStatus | null | undefined, includeObsolete?: boolean | undefined, storefrontId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProjectDto>;
    /**
     * Returns a project by identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<ProjectDto>;
    /**
     * Removes a project by identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(id: number, tenantId?: number | null | undefined): Observable<void>;
    /**
     * Returns a project preview file by project identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPreview(id: number, tenantId?: number | null | undefined): Observable<FileResponse>;
    /**
     * Returns a project preview URL by project identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPreviewUrl(id: number, tenantId?: number | null | undefined): Observable<string>;
    /**
     * Creates a new project with single item.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createWithSingleItem(storefrontId: number, tenantId?: number | null | undefined, body?: CreateSingleItemProjectDto | null | undefined): Observable<ProjectDto>;
    /**
     * Creates a new project with multiple items.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createWithMultipleItems(storefrontId: number, tenantId?: number | null | undefined, body?: CreateMultiItemProjectDto | null | undefined): Observable<ProjectDto>;
    /**
     * Creates a new project by 'Render HiRes' scenario.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createByRenderHiResScenario(storefrontId: number, tenantId?: number | null | undefined, body?: CreateProjectByRenderHiResScenarioDto | null | undefined): Observable<ProjectDto>;
    /**
     * Creates a new project by 'Specific Pipeline' scenario.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createBySpecificPipelineScenario(storefrontId: number, tenantId?: number | null | undefined, body?: CreateProjectBySpecificPipelineScenarioDto | null | undefined): Observable<ProjectDto>;
    /**
     * Returns all available status transitions for a project.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailableTransitions(id: number, tenantId?: number | null | undefined): Observable<PagedOfProjectTransitionDto>;
    /**
     * Changes the project status.
     * @param id Project identifier
     * @param transition Transition identifying name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    changeStatus(id: number, transition: string | null, tenantId?: number | null | undefined): Observable<ProjectStatusDto>;
    /**
     * Changes the project status forcibly without a proper transition.
     * @param id Project identifier.
     * @param status Project status code.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    forceStatus(id: number, status: number, tenantId?: number | null | undefined): Observable<ProjectStatusDto>;
    /**
     * Deletes specified projects. 
    These projects will be hide from projects list immediately, but complete projects data cleaning will take some additional time.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    batchDelete(tenantId?: number | null | undefined, body?: BatchDeleteProjectsInput | null | undefined): Observable<PagedOfProjectStatusDto>;
    /**
     * Returns a list of all existing project statuses.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllStatuses(tenantId?: number | null | undefined): Observable<PagedOfProjectStatusDto>;
    /**
     * Returns a list of all existing project status transitions.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllTransitions(tenantId?: number | null | undefined): Observable<PagedOfProjectTransitionDto>;
    /**
     * Returns a project processing results.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProjectProcessingResults(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProjectProcessingResultsDto>;
    /**
     * Resumes project processing.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier. If value is set, only specified item processing will be resumed.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    resumeProjectProcessing(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined): Observable<void>;
    /**
     * Restarts a project processing routine.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier. If value is set, only specified item processing will be restarted.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    restartProjectProcessing(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined): Observable<void>;
    /**
     * Returns an order description from the ecommerce system for the specified project.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProjectOrder(id: number, tenantId?: number | null | undefined): Observable<any>;
    /**
     * Attachs the specified data to the project's order in ecommerce system.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) A list of data items, which should be attached to project's order.
     * @return Success
     */
    attachDataToProjectOrder(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined, body?: OrderDataItemDto[] | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectsApiClient extends ApiClientBase implements IProjectsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all projects, relevant to the specified query parameters.
     * @param ownerId (optional) Project owner (storefront user id) filter.
     * @param productReference (optional) Product reference filter.
     * @param status (optional) Project status filter.
     * @param datePeriod (optional) Project date period filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param orderId (optional) Identifier of corresponding order.
     * @param processingStatus (optional) Project processing status filter.
     * @param includeObsolete (optional) Indicates if obsolete projects prepared to be removed should be included to result.
     * @param storefrontId (optional) Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(ownerId?: string | null | undefined, productReference?: string | null | undefined, status?: number | null | undefined, datePeriod?: DatePeriod | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, orderId?: string | null | undefined, processingStatus?: ProjectProcessingStatus | null | undefined, includeObsolete?: boolean | undefined, storefrontId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProjectDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects?";
        if (ownerId !== undefined && ownerId !== null)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (datePeriod === null)
            throw new Error("The parameter 'datePeriod' cannot be null.");
        else if (datePeriod !== undefined)
            url_ += "datePeriod=" + encodeURIComponent("" + datePeriod) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (processingStatus !== undefined && processingStatus !== null)
            url_ += "processingStatus=" + encodeURIComponent("" + processingStatus) + "&";
        if (includeObsolete === null)
            throw new Error("The parameter 'includeObsolete' cannot be null.");
        else if (includeObsolete !== undefined)
            url_ += "includeObsolete=" + encodeURIComponent("" + includeObsolete) + "&";
        if (storefrontId !== undefined && storefrontId !== null)
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProjectDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProjectDto>(<any>null);
    }

    /**
     * Returns a project by identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<ProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(<any>null);
    }

    /**
     * Removes a project by identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(id: number, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns a project preview file by project identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPreview(id: number, tenantId?: number | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/preview?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPreview(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPreview(<any>r));
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPreview(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    /**
     * Returns a project preview URL by project identifier.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getPreviewUrl(id: number, tenantId?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/preview-url?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPreviewUrl(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPreviewUrl(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPreviewUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>_responseText;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Creates a new project with single item.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createWithSingleItem(storefrontId: number, tenantId?: number | null | undefined, body?: CreateSingleItemProjectDto | null | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/with-single-item?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateWithSingleItem(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateWithSingleItem(<any>r));
                } catch (e) {
                    return <Observable<ProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateWithSingleItem(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <ProjectDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(<any>null);
    }

    /**
     * Creates a new project with multiple items.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createWithMultipleItems(storefrontId: number, tenantId?: number | null | undefined, body?: CreateMultiItemProjectDto | null | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/with-multiple-items?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateWithMultipleItems(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateWithMultipleItems(<any>r));
                } catch (e) {
                    return <Observable<ProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateWithMultipleItems(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <ProjectDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(<any>null);
    }

    /**
     * Creates a new project by 'Render HiRes' scenario.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createByRenderHiResScenario(storefrontId: number, tenantId?: number | null | undefined, body?: CreateProjectByRenderHiResScenarioDto | null | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/by-scenario/render-hires?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateByRenderHiResScenario(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateByRenderHiResScenario(<any>r));
                } catch (e) {
                    return <Observable<ProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateByRenderHiResScenario(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <ProjectDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(<any>null);
    }

    /**
     * Creates a new project by 'Specific Pipeline' scenario.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    createBySpecificPipelineScenario(storefrontId: number, tenantId?: number | null | undefined, body?: CreateProjectBySpecificPipelineScenarioDto | null | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/by-scenario/specific-pipeline?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateBySpecificPipelineScenario(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateBySpecificPipelineScenario(<any>r));
                } catch (e) {
                    return <Observable<ProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBySpecificPipelineScenario(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <ProjectDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(<any>null);
    }

    /**
     * Returns all available status transitions for a project.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailableTransitions(id: number, tenantId?: number | null | undefined): Observable<PagedOfProjectTransitionDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/transitions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAvailableTransitions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAvailableTransitions(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProjectTransitionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProjectTransitionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableTransitions(response: HttpResponseBase): Observable<PagedOfProjectTransitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProjectTransitionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProjectTransitionDto>(<any>null);
    }

    /**
     * Changes the project status.
     * @param id Project identifier
     * @param transition Transition identifying name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    changeStatus(id: number, transition: string | null, tenantId?: number | null | undefined): Observable<ProjectStatusDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/transitions/{transition}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (transition === undefined || transition === null)
            throw new Error("The parameter 'transition' must be defined.");
        url_ = url_.replace("{transition}", encodeURIComponent("" + transition));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangeStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangeStatus(<any>r));
                } catch (e) {
                    return <Observable<ProjectStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<ProjectStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectStatusDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <ProjectTransitionConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStatusDto>(<any>null);
    }

    /**
     * Changes the project status forcibly without a proper transition.
     * @param id Project identifier.
     * @param status Project status code.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    forceStatus(id: number, status: number, tenantId?: number | null | undefined): Observable<ProjectStatusDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/statuses/{status}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processForceStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processForceStatus(<any>r));
                } catch (e) {
                    return <Observable<ProjectStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processForceStatus(response: HttpResponseBase): Observable<ProjectStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectStatusDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStatusDto>(<any>null);
    }

    /**
     * Deletes specified projects. 
    These projects will be hide from projects list immediately, but complete projects data cleaning will take some additional time.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    batchDelete(tenantId?: number | null | undefined, body?: BatchDeleteProjectsInput | null | undefined): Observable<PagedOfProjectStatusDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/batch-delete?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processBatchDelete(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processBatchDelete(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProjectStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProjectStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<PagedOfProjectStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProjectStatusDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProjectStatusDto>(<any>null);
    }

    /**
     * Returns a list of all existing project statuses.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllStatuses(tenantId?: number | null | undefined): Observable<PagedOfProjectStatusDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/statuses?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllStatuses(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllStatuses(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProjectStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProjectStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStatuses(response: HttpResponseBase): Observable<PagedOfProjectStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProjectStatusDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProjectStatusDto>(<any>null);
    }

    /**
     * Returns a list of all existing project status transitions.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllTransitions(tenantId?: number | null | undefined): Observable<PagedOfProjectTransitionDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/transitions?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllTransitions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllTransitions(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProjectTransitionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProjectTransitionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTransitions(response: HttpResponseBase): Observable<PagedOfProjectTransitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProjectTransitionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProjectTransitionDto>(<any>null);
    }

    /**
     * Returns a project processing results.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProjectProcessingResults(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProjectProcessingResultsDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/processing-results?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProjectProcessingResults(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProjectProcessingResults(<any>r));
                } catch (e) {
                    return <Observable<ProjectProcessingResultsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectProcessingResultsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProjectProcessingResults(response: HttpResponseBase): Observable<ProjectProcessingResultsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectProcessingResultsDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectProcessingResultsDto>(<any>null);
    }

    /**
     * Resumes project processing.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier. If value is set, only specified item processing will be resumed.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    resumeProjectProcessing(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/resume-processing?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResumeProjectProcessing(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResumeProjectProcessing(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResumeProjectProcessing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Restarts a project processing routine.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier. If value is set, only specified item processing will be restarted.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    restartProjectProcessing(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/restart-processing?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRestartProjectProcessing(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRestartProjectProcessing(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestartProjectProcessing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns an order description from the ecommerce system for the specified project.
     * @param id Project identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProjectOrder(id: number, tenantId?: number | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/order?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProjectOrder(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProjectOrder(<any>r));
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processGetProjectOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * Attachs the specified data to the project's order in ecommerce system.
     * @param id Project identifier.
     * @param itemId (optional) Project item identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) A list of data items, which should be attached to project's order.
     * @return Success
     */
    attachDataToProjectOrder(id: number, itemId?: number | null | undefined, tenantId?: number | null | undefined, body?: OrderDataItemDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/projects/{id}/order-data?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId !== undefined && itemId !== null)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAttachDataToProjectOrder(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAttachDataToProjectOrder(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAttachDataToProjectOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IStorefrontsApiClient {
    /**
     * Returns all storefronts, relevant to the specified query parameters.
     * @param types (optional) Storefront type filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(types?: StorefrontType[] | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfStorefrontDto>;
    /**
     * Returns a storefront by identifier.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<StorefrontDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StorefrontsApiClient extends ApiClientBase implements IStorefrontsApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all storefronts, relevant to the specified query parameters.
     * @param types (optional) Storefront type filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(types?: StorefrontType[] | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfStorefrontDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefronts?";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfStorefrontDto>(<any>null);
    }

    /**
     * Returns a storefront by identifier.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<StorefrontDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefronts/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<StorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorefrontDto>(<any>null);
    }
}

export interface IStorefrontUsersApiClient {
    /**
     * Returns all storefront users, relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param storefrontUserId (optional) Storefront user identifier.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param includeAnonymous (optional) Flag that indicates if anonymous users should be included. `True` by default.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(storefrontId: number, storefrontUserId?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, includeAnonymous?: boolean | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfStorefrontUserDto>;
    /**
     * Creates a new storefront user.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    create(storefrontId: number, tenantId?: number | null | undefined, body?: CreateStorefrontUserDto | null | undefined): Observable<StorefrontUserDto>;
    /**
     * Returns a storefront user by identifier.
     * @param id Storefront user identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<StorefrontUserDto>;
    /**
     * Registers a storefront user with the specified identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    register(storefrontId: number, tenantId?: number | null | undefined, body?: RegisterStorefrontUserInput | null | undefined): Observable<StorefrontUserDto>;
    /**
     * Transfers all existing data for the anonymous storefront user to the selected regular storefront user account.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    mergeAnonymous(storefrontId: number, tenantId?: number | null | undefined, body?: MergeAnonymousUserDataInput | null | undefined): Observable<void>;
    /**
     * Returns an API access token for the specified storefront user.
     * @param storefrontUserId Storefront user identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getToken(storefrontUserId: string, storefrontId: number, tenantId?: number | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class StorefrontUsersApiClient extends ApiClientBase implements IStorefrontUsersApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all storefront users, relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param storefrontUserId (optional) Storefront user identifier.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param includeAnonymous (optional) Flag that indicates if anonymous users should be included. `True` by default.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(storefrontId: number, storefrontUserId?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, includeAnonymous?: boolean | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfStorefrontUserDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefront-users?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (storefrontUserId !== undefined && storefrontUserId !== null)
            url_ += "storefrontUserId=" + encodeURIComponent("" + storefrontUserId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (includeAnonymous !== undefined && includeAnonymous !== null)
            url_ += "includeAnonymous=" + encodeURIComponent("" + includeAnonymous) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfStorefrontUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfStorefrontUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfStorefrontUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfStorefrontUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfStorefrontUserDto>(<any>null);
    }

    /**
     * Creates a new storefront user.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    create(storefrontId: number, tenantId?: number | null | undefined, body?: CreateStorefrontUserDto | null | undefined): Observable<StorefrontUserDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefront-users?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(<any>r));
                } catch (e) {
                    return <Observable<StorefrontUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorefrontUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StorefrontUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <StorefrontUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorefrontUserDto>(<any>null);
    }

    /**
     * Returns a storefront user by identifier.
     * @param id Storefront user identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<StorefrontUserDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefront-users/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<StorefrontUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorefrontUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StorefrontUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StorefrontUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorefrontUserDto>(<any>null);
    }

    /**
     * Registers a storefront user with the specified identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    register(storefrontId: number, tenantId?: number | null | undefined, body?: RegisterStorefrontUserInput | null | undefined): Observable<StorefrontUserDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefront-users/register?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRegister(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRegister(<any>r));
                } catch (e) {
                    return <Observable<StorefrontUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorefrontUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<StorefrontUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StorefrontUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorefrontUserDto>(<any>null);
    }

    /**
     * Transfers all existing data for the anonymous storefront user to the selected regular storefront user account.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Operation parameters.
     * @return Success
     */
    mergeAnonymous(storefrontId: number, tenantId?: number | null | undefined, body?: MergeAnonymousUserDataInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefront-users/merge-anonymous?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMergeAnonymous(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMergeAnonymous(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMergeAnonymous(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns an API access token for the specified storefront user.
     * @param storefrontUserId Storefront user identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getToken(storefrontUserId: string, storefrontId: number, tenantId?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/storefront/v1/storefront-users/token?";
        if (storefrontUserId === undefined || storefrontUserId === null)
            throw new Error("The parameter 'storefrontUserId' must be defined and cannot be null.");
        else
            url_ += "storefrontUserId=" + encodeURIComponent("" + storefrontUserId) + "&";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetToken(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetToken(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>_responseText;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface ITenantInfoApiClient {
    /**
     * Returns an information about the tenant applications.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getApplicationsInfo(tenantId?: number | null | undefined): Observable<TenantApplicationsInfoDto>;
    /**
     * Returns an information about the tenant.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getInfo(tenantId?: number | null | undefined): Observable<TenantInfoDto>;
    /**
     * Returns an information about the tenant measure units.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getMeasureUnitsInfo(tenantId?: number | null | undefined): Observable<TenantMeasureUnitsInfoDto>;
    /**
     * Returns a list of tenant users.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getUsersInfo(tenantId?: number | null | undefined): Observable<TenantUserInfoDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TenantInfoApiClient extends ApiClientBase implements ITenantInfoApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns an information about the tenant applications.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getApplicationsInfo(tenantId?: number | null | undefined): Observable<TenantApplicationsInfoDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/tenant-info/applications?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetApplicationsInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetApplicationsInfo(<any>r));
                } catch (e) {
                    return <Observable<TenantApplicationsInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantApplicationsInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationsInfo(response: HttpResponseBase): Observable<TenantApplicationsInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TenantApplicationsInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantApplicationsInfoDto>(<any>null);
    }

    /**
     * Returns an information about the tenant.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getInfo(tenantId?: number | null | undefined): Observable<TenantInfoDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/tenant-info?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInfo(<any>r));
                } catch (e) {
                    return <Observable<TenantInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<TenantInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TenantInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantInfoDto>(<any>null);
    }

    /**
     * Returns an information about the tenant measure units.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getMeasureUnitsInfo(tenantId?: number | null | undefined): Observable<TenantMeasureUnitsInfoDto> {
        let url_ = this.baseUrl + "/api/storefront/v1/tenant-info/measure-units?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMeasureUnitsInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMeasureUnitsInfo(<any>r));
                } catch (e) {
                    return <Observable<TenantMeasureUnitsInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantMeasureUnitsInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMeasureUnitsInfo(response: HttpResponseBase): Observable<TenantMeasureUnitsInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TenantMeasureUnitsInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantMeasureUnitsInfoDto>(<any>null);
    }

    /**
     * Returns a list of tenant users.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getUsersInfo(tenantId?: number | null | undefined): Observable<TenantUserInfoDto[]> {
        let url_ = this.baseUrl + "/api/storefront/v1/tenant-info/users?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUsersInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUsersInfo(<any>r));
                } catch (e) {
                    return <Observable<TenantUserInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersInfo(response: HttpResponseBase): Observable<TenantUserInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TenantUserInfoDto[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserInfoDto[]>(<any>null);
    }
}

/** Information about a service. */
export interface BuildInfoModel {
    /** Version number. */
    version?: string | null;
    /** Build date (UTC). */
    buildDate?: string | null;
    /** Build configuration (Debug | Release). */
    configuration?: string | null;
    /** Service name. */
    appName?: string | null;
}

/** Dto class, containing information about processing pipeline details. */
export interface ProcessingPipelineDto {
    /** Processing pipeline identifier. */
    id?: number;
    /** Processing pipeline name. */
    name?: string | null;
    /** Processing pipeline raw (uncompiled) content. */
    rawContent?: string | null;
}

/** Paged list of items. */
export interface PagedOfProcessingPipelineDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProcessingPipelineDto[] | null;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

/** DTO class, containing information about a product resource of type image. */
export interface ImageInfo {
    /** Product resource identifier. */
    resourceId?: string | null;
    /** Product Resource URL. */
    url?: string | null;
}

/** Product bundle resource type. */
export enum ProductBundleResourceType {
    Custom = "Custom",
    Preview = "Preview",
}

/** DTO class, containing information about a product bundle resource. */
export interface ProductBundleResourceDto {
    /** Product bundle resource identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Resource identifier. */
    resourceId?: string | null;
    /** Resource name. */
    name?: string | null;
    /** Resource namespace. */
    namespace?: string | null;
    /** Resource type. */
    type?: ProductBundleResourceType;
    /** Resource URL. */
    url?: string | null;
}

/** DTO class, containing information about a product bundle item. */
export interface ProductBundleItemDto {
    /** Product bundle item identifier. */
    id?: number;
    /** Bundled product identifier. */
    productId?: number | null;
    /** Bundled product version identifier. */
    productVersionId?: number | null;
    /** Bundled product name. */
    productName?: string | null;
    /** Bundled product variant identifier. */
    productVariantId?: number | null;
    /** Bundled product variant UID. */
    productVariantUID?: string | null;
    /** Bundled product variant Name. */
    productVariantName?: string | null;
    /** Bundled product variant SKU. */
    productVariantSku?: string | null;
    /** Product bundle item image info. */
    image?: ImageInfo | null;
    /** Product bundle item resources. */
    resources?: ProductBundleResourceDto[] | null;
}

/** DTO class, containing information about a product bundle. */
export interface ProductBundleDto {
    /** Product bundle identifier. */
    id?: number;
    /** Product bundle version identifier. */
    productBundleVersionId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product bundle name. */
    name?: string | null;
    /** Product bundle description. */
    description?: string | null;
    /** Product bundle creation time. */
    created?: string;
    /** Product bundle las modification time. */
    lastModified?: string | null;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number | null;
    /** Product bundle custom fields. */
    customFields?: { [key: string]: string; } | null;
    /** Product bundle image info. */
    image?: ImageInfo | null;
    /** Product bundle items. */
    items?: ProductBundleItemDto[] | null;
    /** Product bundle resources. */
    resources?: ProductBundleResourceDto[] | null;
}

/** Paged list of items. */
export interface PagedOfProductBundleDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductBundleDto[] | null;
}

/** Conflict types. */
export enum ConflictType {
    NameConflict = "NameConflict",
    FolderOverwriteConflict = "FolderOverwriteConflict",
    IdConflict = "IdConflict",
    GeneralConflict = "GeneralConflict",
}

/** Information about operation conflict. */
export interface GeneralConflictDto {
    /** Problem description. */
    description?: string | null;
    /** Coflict type. */
    type?: ConflictType;
}

/** Available appearance types. */
export enum AppearanceDataType {
    Radio = "Radio",
    Dropdown = "Dropdown",
    Chips = "Chips",
    ColorGrid = "ColorGrid",
    ColorList = "ColorList",
    ImageGrid = "ImageGrid",
    ImageList = "ImageList",
}

/** DTO class, containing information about a product option appearance item. */
export interface AppearanceDataItemDto {
    /** Appearance item key. */
    key?: string | null;
    /** Appearance item value. */
    value?: string | null;
}

/** DTO class, containing information about a product option appearance. */
export interface AppearanceDataDto {
    /** Appearance type. */
    type?: AppearanceDataType;
    /** Appearance items. */
    items?: AppearanceDataItemDto[] | null;
}

/** Option values for product summary model. */
export interface ProductSummaryOptionValueDto {
    /** Option value identifier. */
    id?: number;
    /** Option value identifying tag. */
    tag?: string | null;
    /** Product option value UID. */
    uid?: string | null;
    /** Option value title. */
    title?: string | null;
    /** Option value value. */
    value?: string | null;
    /** Indicates if option value is used as a default value. */
    isDefault?: boolean;
    /** Option value description. */
    description?: string | null;
    /** Option value colors. */
    colors?: string[] | null;
    /** Option value image. */
    image?: ImageInfo | null;
}

/** Options for product summary model. */
export interface ProductSummaryOptionDto {
    /** Option identifier. */
    id?: number;
    /** Option identifying tag. */
    tag?: string | null;
    /** Product option UID. */
    uid?: string | null;
    /** Option title. */
    title?: string | null;
    /** Option description. */
    description?: string | null;
    /** Option tooltip. */
    tooltip?: string | null;
    /** Option sort index. */
    sortIndex?: number;
    /** Option traits. */
    traits?: string[] | null;
    /** Indicates if option is used to bind designs to product. */
    useForDesignBinding?: boolean;
    /** Indicates if option is used to bind mockups to product. */
    useForMockupBinding?: boolean;
    /** Indicates if option is used to bind documents to product. */
    useForDocumentBinding?: boolean;
    /** Option appearance. */
    appearanceData?: AppearanceDataDto | null;
    /** Option image info. */
    image?: ImageInfo | null;
    /** Option values. */
    productOptionValues?: ProductSummaryOptionValueDto[] | null;
}

/** General information about product that editors need to begin personalization process. */
export interface ProductSummaryDto {
    /** Product identifier. */
    productId?: number;
    /** Product version identifier. If product variant is not specified, active version identifier should be used. */
    productVersionId?: number;
    /** Product link identifier. If product link is not specified, should be null. */
    productLinkId?: number | null;
    /** Product link version identifier. If product link is not specified, should be null. */
    productLinkVersionId?: number | null;
    /** Product filter identifier for product link. If product link is not specified, should be null. */
    productFilterId?: number | null;
    /** Product bundle identifier. If product bundle is not specified, should be null. */
    productBundleId?: number | null;
    /** Product bundle version identifier. If product bundle is not specified, should be null. */
    productBundleVersionId?: number | null;
    /** Product variant identifier. If product variant is not specified, should be null. */
    productVariantId?: number | null;
    /** Product variant SKU. If product variant is not specified, should be null. */
    productVariantSku?: string | null;
    /** Product variant price. If product variant is not specified, should be null. */
    productVariantPrice?: number | null;
    /** Product variant availability. If product variant is not specified, should be null. */
    isProductVariantAvailable?: boolean | null;
    /** Product name. If product link is specified, name of link will be used. */
    name?: string | null;
    /** Product description. If product link is specified, description of link will be used. */
    description?: string | null;
    /** Product image info. */
    image?: ImageInfo | null;
    /** Tenant identifier. */
    tenantId?: number;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number | null;
    /** Processing pipeline identifier. */
    processingPipelineId?: number | null;
    /** Product tags. */
    tags?: string[] | null;
    /** Product custom fields. */
    customFields?: { [key: string]: string; } | null;
    /** Product options summary. 
If product link or variant is specified, product options will be filtered by link or variant options. */
    options?: ProductSummaryOptionDto[] | null;
}

/** Type of editor that should be configured by workflow. */
export enum WorkflowType {
    UIFramework = "UIFramework",
    SimpleEditor = "SimpleEditor",
    DesignEditor = "DesignEditor",
    WorkflowElements = "WorkflowElements",
}

/** Personalization workflow description DTO. */
export interface PersonalizationWorkflowDto {
    /** Workflow identifier. */
    id?: number;
    /** Processed workflow JSON. */
    content?: string | null;
    /** Workflow type. */
    workflowType?: WorkflowType;
}

/** Product link resource type. */
export enum ProductLinkResourceType {
    Preview = "Preview",
    Custom = "Custom",
}

/** DTO class, containing information about a product link resource. */
export interface ProductLinkResourceDto {
    /** Product link resource identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Resource identifier. */
    resourceId?: string | null;
    /** Resource name. */
    name?: string | null;
    /** Resource namespace. */
    namespace?: string | null;
    /** Resource type. */
    type?: ProductLinkResourceType;
    /** Resource URL. */
    url?: string | null;
}

/** Available option types. */
export enum OptionType {
    Simple = "Simple",
    Size = "Size",
    PageCount = "PageCount",
}

/** DTO class, containing information about a product filter option. */
export interface ProductFilterOptionDto {
    /** Product option identifier. */
    productOptionId?: number | null;
    /** Product option value identifier. */
    productOptionValueId?: number | null;
    /** Product option type ('Simple' / 'Size' / 'PageCount'). */
    productOptionType?: OptionType;
    /** Product option traits. */
    productOptionTraits?: string[] | null;
    /** Product option title. */
    productOptionTitle?: string | null;
    /** Product option value title. */
    productOptionValueTitle?: string | null;
    /** Indicates if option value should be used as a default value for corresponding option. */
    isDefault?: boolean;
}

/** DTO class, containing information about a product link. */
export interface ProductLinkDto {
    /** Product link identifier. */
    id?: number;
    /** Product link version identifier. */
    productLinkVersionId?: number;
    /** Linked product identifier. */
    productId?: number;
    /** Linked product version identifier. */
    productVersionId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product link name. */
    name?: string | null;
    /** Product link description. */
    description?: string | null;
    /** Product filter identifier. */
    productFilterId?: number;
    /** Product link image info. */
    image?: ImageInfo | null;
    /** Product link resources. */
    resources?: ProductLinkResourceDto[] | null;
    /** Product link creation time. */
    created?: string;
    /** Product link modification time. */
    lastModified?: string | null;
    /** Product filter options. */
    productFilterOptions?: ProductFilterOptionDto[] | null;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number | null;
    /** Processing pipeline identifier. */
    processingPipelineId?: number | null;
    /** Default storefront identifier. */
    storefrontId?: number | null;
    /** Default storefront product identifier. */
    storefrontProductId?: string | null;
    /** Default storefront product name. */
    storefrontProductName?: string | null;
}

/** Paged list of items. */
export interface PagedOfProductLinkDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductLinkDto[] | null;
}

/** Available product reference target types. */
export enum ProductReferenceType {
    ProductSpecification = "ProductSpecification",
    Product = "Product",
    ProductLink = "ProductLink",
    ProductBundle = "ProductBundle",
}

/** DTO class, containing information about storefront product reference. */
export interface ProductReferenceDto {
    /** Product reference is an external reference to Customer's Canvas product, e.g online store product identifier. */
    productReference?: string | null;
    /** Product reference target type. */
    productReferenceType?: ProductReferenceType;
    /** Product reference name, e.g. online store product name. */
    productReferenceName?: string | null;
    /** Customer's Canvas product specification identifier. */
    productSpecificationId?: number;
    /** Customer's Canvas product identifier. */
    productId?: number;
    /** Customer's Canvas product version identifier. */
    productVersionId?: number;
    /** Customer's Canvas product link identifier. */
    productLinkId?: number;
    /** Customer's Canvas product bundle identifier. */
    productBundleId?: number;
    /** Storefront identifier. */
    storefrontId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront product reference creation date and time. */
    created?: string;
}

/** Paged list of items. */
export interface PagedOfProductReferenceDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductReferenceDto[] | null;
}

/** Dto class, containing information about product attribute. */
export interface ProductAttributeDto {
    /** Product attribute name. */
    name?: string | null;
    /** Product attribute type. */
    type?: string | null;
    /** Product attribute value. */
    value?: any | null;
}

/** Dto class, containing information about product specification. */
export interface ProductSpecificationDto {
    /** Product specification identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product specification name. */
    name?: string | null;
    /** Product specification description. */
    description?: string | null;
    /** List of product attributes. */
    productAttributes?: ProductAttributeDto[] | null;
    /** Product specification creation time. */
    created?: string;
    /** Product specification modification time. */
    lastModified?: string | null;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number;
    /** Processing pipeline identifier. */
    processingPipelineId?: number;
}

/** Paged list of items. */
export interface PagedOfProductSpecificationDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductSpecificationDto[] | null;
}

/** DTO class, containing information about a product. */
export interface ProductDto {
    /** Product identifier. */
    id?: number;
    /** Product version identifier. */
    productVersionId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product name. */
    name?: string | null;
    /** Product description. */
    description?: string | null;
    /** Product image info. */
    image?: ImageInfo | null;
    /** Product creation time. */
    created?: string;
    /** Product modification time. */
    lastModified?: string | null;
    /** Product tags. */
    tags?: string[] | null;
    /** Product custom fields. */
    customFields?: { [key: string]: string; } | null;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number;
    /** Processing pipeline identifier. */
    processingPipelineId?: number;
    /** Default storefront identifier. */
    storefrontId?: number | null;
    /** Default storefront product identifier. */
    storefrontProductId?: string | null;
    /** Default storefront product name. */
    storefrontProductName?: string | null;
}

/** Paged list of items. */
export interface PagedOfProductDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductDto[] | null;
}

/** Dto class, containing information about storefront product cost details. */
export interface ProductCostDetailsDto {
    /** Product reference is an external reference to Customer's Canvas product specification, e.g online store product identifier. */
    productReference?: string | null;
    /** Product SKU. */
    productSku?: string | null;
    /** Product quantity. */
    productQuantity?: number;
    /** Product price. */
    productPrice?: number;
    /** Product cost. */
    productCost?: number;
    /** Product discount. */
    productDiscount?: number;
    /** Currency code. */
    currencyCode?: string | null;
    /** Tenant identifier. */
    tenantId?: number;
}

/** Option value description for 'Simple' option type. */
export interface SimpleOptionValue {
    /** String Value. */
    value?: string | null;
}

/** DTO class, containing information about a product option value. */
export interface ProductOptionValueDto {
    /** Product option value identifier. */
    id?: number;
    /** Product option value title. */
    title?: string | null;
    /** Product option value sort index. */
    sortIndex?: number;
    /** Indicates if product option value is used as a default value. */
    isDefault?: boolean;
    /** Product option value identifying tag. */
    tag?: string | null;
    /** Product option value UID. */
    uid?: string | null;
    /** Product option value description for 'Simple' option type. */
    simpleOptionValue?: SimpleOptionValue | null;
    /** Product option value description. */
    description?: string | null;
    /** Product option value colors. */
    colors?: string[] | null;
    /** Product option value image. */
    image?: ImageInfo | null;
}

/** DTO class, containing information about a product option. */
export interface ProductOptionDto {
    /** Product option identifier. */
    id?: number;
    /** Product version identifier */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Option type ('Simple' / 'Size' / 'PageCount'). */
    type?: OptionType;
    /** Option traits. */
    traits?: string[] | null;
    /** Product option title. */
    title?: string | null;
    /** Product option sort index. */
    sortIndex?: number;
    /** Product option identifying tag. */
    tag?: string | null;
    /** Product option UID. */
    uid?: string | null;
    /** Specifies if the option is used for design binding. */
    useForDesignBinding?: boolean;
    /** Specifies if the option is used for mockup binding. */
    useForMockupBinding?: boolean;
    /** Specifies if the option is used for document binding. */
    useForDocumentBinding?: boolean;
    /** Product option description. */
    description?: string | null;
    /** Product option tooltip. */
    tooltip?: string | null;
    /** Product option appearance. */
    appearanceData?: AppearanceDataDto | null;
    /** Product option image info. */
    image?: ImageInfo | null;
    /** A list of product option values. */
    productOptionValues?: ProductOptionValueDto[] | null;
}

/** Paged list of items. */
export interface PagedOfProductOptionDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductOptionDto[] | null;
}

/** DTO class, containing information about a product variant option. */
export interface ProductVariantOptionDto {
    /** Product option identifier. */
    productOptionId?: number | null;
    /** Product option value identifier. */
    productOptionValueId?: number | null;
    /** Product option type ('Simple' / 'Size' / 'PageCount'). */
    productOptionType?: OptionType;
    /** Product option traits. */
    productOptionTraits?: string[] | null;
    /** Product option title. */
    productOptionTitle?: string | null;
    /** Product option value title. */
    productOptionValueTitle?: string | null;
    /** Product option value description for 'Simple' option type. */
    simpleOptionValue?: SimpleOptionValue | null;
}

/** DTO class, containing information about a product variant. */
export interface ProductVariantDto {
    /** Product variant identifier. */
    id?: number;
    /** Product variant unique identifier. */
    uid?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product variant available. */
    isAvailable?: boolean;
    /** Product variant price. */
    price?: number | null;
    /** Product variant sort index. */
    sortIndex?: number;
    /** Product variant identifier (usually SKU) in storefront / online store. */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
}

/** Paged list of items. */
export interface PagedOfProductVariantDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductVariantDto[] | null;
}

/** Available product variant resource types. */
export enum ProductVariantResourceType {
    Preview = "Preview",
    EditorModel = "EditorModel",
    Custom = "Custom",
}

/** Product variant resource description for 'Preview' resource type. */
export interface ProductVariantResourcePreview {
    /** Preview with in pixels. */
    width?: number | null;
    /** Preview heigth in pixels. */
    height?: number | null;
    /** Mockup which is used to create preview. */
    mockupId?: string | null;
    /** Design surface index which is used to create preivew. */
    surfaceIndex?: number | null;
}

/** DTO class, containing information about a product variant resource. */
export interface ProductVariantResourceDto {
    /** Resource identifier. */
    resourceId?: string | null;
    /** Resource name. */
    name?: string | null;
    /** Resource url. */
    url?: string | null;
    /** Resource type. */
    type?: ProductVariantResourceType;
    /** Product variant resource description for 'Preview' resource type. */
    resourcePreview?: ProductVariantResourcePreview | null;
}

/** DTO class, containing information about a product variant design. */
export interface ProductVariantDesignDto {
    /** Product variant identifier. */
    productVariantId?: number;
    /** Product variant unique identifier. */
    productVariantUID?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product variant available. */
    isAvailable?: boolean;
    /** Product variant price. */
    price?: number | null;
    /** Product variant sort index. */
    sortIndex?: number;
    /** Product variant identifier (usually SKU) in storefront / online store. */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** Design identifier. */
    designId?: string | null;
    /** Design name. */
    designName?: string | null;
    /** Design grouping tag. */
    designGroup?: string | null;
    /** Design data schema tag. Indicates if design has data schema. */
    designHasDataSchema?: boolean;
    /** Design toggle set tag. Indicated if design has toggle set. */
    designHasToggleSet?: boolean;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
    /** A list of product variant resources. */
    productVariantResources?: ProductVariantResourceDto[] | null;
}

/** Paged list of items. */
export interface PagedOfProductVariantDesignDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductVariantDesignDto[] | null;
}

/** Available mockup types. */
export enum ProductVariantMockupType {
    Thumbnail = "Thumbnail",
    Editor = "Editor",
    Preview = "Preview",
}

/** Available surface usage types. */
export enum SurfaceUsageType {
    Individual = "Individual",
    Custom = "Custom",
    All = "All",
}

/** Dto class, containing information about a product variant mockup. */
export interface ProductVariantMockupDto {
    /** Product variant identifier. */
    productVariantId?: number;
    /** Product variant unique identifier. */
    productVariantUID?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number | null;
    /** Product variant identifier in online store (usually SKU). */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** Mockup identifier. */
    mockupId?: string | null;
    /** Mockup name. */
    mockupName?: string | null;
    /** Mockup type. */
    mockupType?: ProductVariantMockupType;
    /** Surface index indicates a surface of a design to which mockup should be applied. */
    surfaceIndex?: number | null;
    /** Surface usage type defines a scheme for applying mockup to design surfaces. */
    surfaceUsageType?: SurfaceUsageType;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
}

/** Paged list of items. */
export interface PagedOfProductVariantMockupDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductVariantMockupDto[] | null;
}

/** DTO class, containing information about a product variant document. */
export interface ProductVariantDocumentDto {
    /** Product variant identifier. */
    productVariantId?: number;
    /** Product variant unique identifier. */
    productVariantUID?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product variant available. */
    isAvailable?: boolean;
    /** Product variant price. */
    price?: number | null;
    /** Product variant sort index. */
    sortIndex?: number;
    /** Product variant identifier (usually SKU) in storefront / online store. */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** Document identifier. */
    documentId?: string | null;
    /** Document name. */
    documentName?: string | null;
    /** Document grouping tag. */
    documentGroup?: string | null;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
    /** A list of product variant resources. */
    productVariantResources?: ProductVariantResourceDto[] | null;
}

/** Paged list of items. */
export interface PagedOfProductVariantDocumentDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProductVariantDocumentDto[] | null;
}

/** Defines all available date period filter values for queries. */
export enum DatePeriod {
    All = "All",
    Today = "Today",
    Last7Days = "Last7Days",
    Last30Days = "Last30Days",
}

/** Available project processing statuses. */
export enum ProjectProcessingStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
}

/** Available product resource types */
export enum ProjectItemResourceType {
    General = "General",
    Preview = "Preview",
    Hires = "Hires",
}

/** Dto class, containing information about a project item resource. */
export interface ProjectItemResourceDto {
    /** Resource ID. */
    resourceId?: string | null;
    /** Resource name. */
    name?: string | null;
    /** Resource type. */
    type?: ProjectItemResourceType;
}

/** Dto class, containing information about a project item. */
export interface ProjectItemDto {
    /** Item identifier. */
    id?: number;
    /** Item name. */
    name?: string | null;
    /** Item quantity information. */
    quantity?: number | null;
    /** Order item identifier from storefront order. */
    orderLineItemId?: string | null;
    /** Order item index from storefront order. */
    orderLineItemIndex?: number | null;
    /** Storefront product reference (i.e external reference to Customer's Canvas product specification). */
    productReference?: string | null;
    /** Item information. */
    fields?: { [key: string]: any; } | null;
    /** Additional item information. */
    hidden?: any | null;
    /** A list of design identifiers associated to the item. */
    designIds?: string[] | null;
    /** SKU. */
    sku?: string | null;
    /** External resources descriptions. */
    resources?: ProjectItemResourceDto[] | null;
}

/** Dto class, containing information about a project. */
export interface ProjectDto {
    /** Project identifier. */
    id?: number;
    /** Storefront product identifier. */
    productReference?: string | null;
    /** Storefront identifier. */
    storefrontId?: number;
    /** Project tenant indentifier. */
    tenantId?: number;
    /** Order identifier in ecommerce system. */
    orderId?: string | null;
    /** Order url in ecommerce system. */
    orderUrl?: string | null;
    /** Order number in ecommerce system. */
    orderNumber?: number | null;
    /** Order item identifier from storefront order. */
    orderLineItemId?: string | null;
    /** Order item index from storefront order. */
    orderLineItemIndex?: number | null;
    /** Customer identifier in ecommerce system. */
    customerId?: string | null;
    /** Customer name in ecommerce system. */
    customerName?: string | null;
    /** Project name. */
    name?: string | null;
    /** Project owner identifier. */
    ownerId?: string | null;
    /** List of project items. */
    items?: ProjectItemDto[] | null;
    /** Project status code. */
    status?: number;
    /** Project creation time. */
    created?: string;
    /** Project modification time. */
    lastModified?: string | null;
    /** Description of the project. */
    description?: string | null;
    /** Project processing status. */
    processingStatus?: ProjectProcessingStatus;
}

/** Paged list of items. */
export interface PagedOfProjectDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProjectDto[] | null;
}

/** Dto class, containing create operation parameters for a project item resource. */
export interface ProjectItemResourceParametersDto {
    /** Resource URL. */
    url?: string | null;
    /** Resource name. */
    name?: string | null;
    /** Resource type. */
    type?: ProjectItemResourceType;
    /** Original resource identifier. */
    resourceId?: string | null;
}

export enum ProjectItemProductType {
    ProductSpecification = "ProductSpecification",
    Product = "Product",
    ProductLink = "ProductLink",
}

/** Additional project item product information description. */
export interface ProjectItemProductSpecifierDto {
    /** Customer's Canvas product type. */
    type?: ProjectItemProductType;
    /** Customer's Canvas product identifier.
May keep reference to `Product`, `Product Specification` and `Product Link` (depending on `Type` value). */
    id?: number | null;
    /** Customer's Canvas product version identifier.
May keep reference to version of `Product`, or `Product Link` (depending on `Type` value). */
    versionId?: number | null;
    /** Customer's Canvas product variant identifier.
May keep reference to version of `Product` (depending on `Type` value). */
    variantId?: number | null;
}

/** Dto class, containing create operation parameters for a project item. */
export interface ProjectItemParametersDto {
    /** Item name. */
    name?: string | null;
    /** Item quantity information. */
    quantity?: number | null;
    /** Line item index from ecommerce system order. */
    orderLineItemIndex?: number | null;
    /** Line Item identifier from ecommerce system order. */
    orderLineItemId?: string | null;
    /** Storefront product identifier. */
    productReference?: string | null;
    /** Item information. */
    fields?: { [key: string]: any; } | null;
    /** Additional item information. */
    hidden?: any | null;
    /** A list of design identifiers associated to the item. */
    designIds?: string[] | null;
    /** SKU. */
    sku?: string | null;
    /** External resources descriptions. */
    resources?: ProjectItemResourceParametersDto[] | null;
    /** Additional project item product information description. */
    productSpecifier?: ProjectItemProductSpecifierDto | null;
}

/** Dto class, containing create operation parameters for single-item project entity. */
export interface CreateSingleItemProjectDto {
    /** Product reference (i.e external reference to Customer's Canvas product specification - main subject of this project). */
    productReference?: string | null;
    /** Line item index from ecommerce system order. */
    orderLineItemIndex?: number | null;
    /** Line Item identifier from ecommerce system order. */
    orderLineItemId?: string | null;
    /** List of project items. */
    items?: ProjectItemParametersDto[] | null;
    /** Order identifier in ecommerce system. */
    orderId?: string | null;
    /** Order url in ecommerce system. */
    orderUrl?: string | null;
    /** Order number in ecommerce system. */
    orderNumber?: number | null;
    /** Customer identifier in ecommerce system. */
    customerId?: string | null;
    /** Customer name in ecommerce system. */
    customerName?: string | null;
    /** Project name. */
    name?: string | null;
    /** Project owner identifier. */
    ownerId: string;
    /** List of project items. */
    item?: ProjectItemParametersDto | null;
    /** Description of the project. */
    description?: string | null;
}

/** Dto class, containing create operation parameters for multi-item project entity. */
export interface CreateMultiItemProjectDto {
    /** Order identifier in ecommerce system. */
    orderId?: string | null;
    /** Order url in ecommerce system. */
    orderUrl?: string | null;
    /** Order number in ecommerce system. */
    orderNumber?: number | null;
    /** Customer identifier in ecommerce system. */
    customerId?: string | null;
    /** Customer name in ecommerce system. */
    customerName?: string | null;
    /** Project name. */
    name?: string | null;
    /** Project owner identifier. */
    ownerId: string;
    /** List of project items. */
    items?: ProjectItemParametersDto[] | null;
    /** Description of the project. */
    description?: string | null;
}

/** Dto class, containing ecommerce order description. */
export interface OrderDetailsDto {
    /** Order identifier in ecommerce system. */
    orderId?: string | null;
    /** Order url in ecommerce system. */
    orderUrl?: string | null;
    /** Order number in ecommerce system. */
    orderNumber?: number | null;
    /** Line item index from ecommerce system order. */
    orderLineItemIndex?: number | null;
    /** Line Item identifier from ecommerce system order. */
    orderLineItemId?: string | null;
    /** Customer identifier in ecommerce system. */
    customerId?: string | null;
    /** Customer name in ecommerce system. */
    customerName?: string | null;
}

export enum RenderHiResScenarioOutputFormat {
    Pdf = "Pdf",
    Jpeg = "Jpeg",
    Png = "Png",
    Tiff = "Tiff",
    Bmp = "Bmp",
}

export enum RenderHiResScenarioOutputColorSpace {
    Rgb = "Rgb",
    Grayscale = "Grayscale",
    Cmyk = "Cmyk",
}

export enum RenderHiResScenarioOutputFlipMode {
    None = "None",
    Horizontal = "Horizontal",
    Vertical = "Vertical",
    Both = "Both",
}

export enum RenderHiResScenarioOutputRotateMode {
    None = "None",
    Rotate90 = "Rotate90",
    Rotate180 = "Rotate180",
    Rotate270 = "Rotate270",
    Auto = "Auto",
}

/** Dto class, containing 'RenderHiRes' scenario parameters. */
export interface RenderHiResScenarioDto {
    /** Private design identifier. */
    designId: string;
    /** Output file name (without extension). */
    name?: string | null;
    /** Output file DPI. */
    dpi?: number;
    /** Output file format. */
    format?: RenderHiResScenarioOutputFormat | null;
    /** Output file color space. */
    colorSpace?: RenderHiResScenarioOutputColorSpace | null;
    /** Output file flip mode. */
    flipMode?: RenderHiResScenarioOutputFlipMode | null;
    /** Output file rotate mode. */
    rotateMode?: RenderHiResScenarioOutputRotateMode | null;
    /** Output file access mode. */
    anonymousAccess?: boolean | null;
}

/** Dto class, containing 'create' operation parameters for project entity. */
export interface CreateProjectByRenderHiResScenarioDto {
    /** Project owner identifier. */
    ownerId: string;
    /** Project name. */
    name?: string | null;
    /** Description of the project. */
    description?: string | null;
    /** Ecommerce system order description. */
    orderDetails?: OrderDetailsDto | null;
    /** Line item index from ecommerce system order. */
    orderLineItemIndex?: number | null;
    /** Line Item identifier from ecommerce system order. */
    orderLineItemId?: string | null;
    /** List of project items. */
    scenario: RenderHiResScenarioDto;
}

export interface ItemPipelineDto {
    itemName?: string | null;
    pipelineId?: number;
}

/** Dto class, containing 'Specific Pipeline' scenario parameters. */
export interface SpecificPipelineScenarioDto {
    /** An existing processing pipeline identifier. */
    pipelineId?: number | null;
    /** An existing processing pipeline identifier for project post-processing. */
    postProcessingPipelineId?: number | null;
    /** List of objects describing connections between project items and processing pipelines. */
    itemPipelines?: ItemPipelineDto[] | null;
}

/** Dto class, containing 'create' operation parameters for a new project that should be created by executing 'Specific Pipeline' scenario. */
export interface CreateProjectBySpecificPipelineScenarioDto {
    /** Project owner identifier. */
    ownerId: string;
    /** Project name. */
    name?: string | null;
    /** Description of the project. */
    description?: string | null;
    /** Ecommerce system order description. */
    orderDetails?: OrderDetailsDto | null;
    /** List of project items. */
    items?: ProjectItemParametersDto[] | null;
    /** 'Specific Pipeline' scenario params. For more information check BackOffice.Web.PublicApi.ApiStorefront.Models.SpecificPipelineScenarioDto. */
    scenario: SpecificPipelineScenarioDto;
}

/** Project transition dto class. */
export interface ProjectTransitionDto {
    /** Transition identifying name. */
    name?: string | null;
    /** Transition display name. */
    displayName?: string | null;
    /** Project status code from which transition to the result status code can be done. */
    startStatus?: number;
    /** Transition result project status code. */
    resultStatus?: number;
}

/** Paged list of items. */
export interface PagedOfProjectTransitionDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProjectTransitionDto[] | null;
}

/** Dto class, containing the information about project status. */
export interface ProjectStatusDto {
    /** Status code. */
    code?: number;
    /** Status display name. */
    displayName?: string | null;
}

/** Dto class, containing information about the project transition conflict. */
export interface ProjectTransitionConflictDto {
    /** A list of all available status transitions for the project. */
    availableTransitions?: ProjectTransitionDto[] | null;
    /** Problem description. */
    description?: string | null;
    /** Coflict type. */
    type?: ConflictType;
}

/** Dto class, containing parameters for the 'projects batch delete' operation. */
export interface BatchDeleteProjectsInput {
    /** Identifiers of projects that should be deleted. */
    ids?: number[] | null;
}

/** Paged list of items. */
export interface PagedOfProjectStatusDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: ProjectStatusDto[] | null;
}

/** Dto class, containing description of a project output file. */
export interface ProjectOutputFileDetailsDto {
    /** Project item identifier. */
    projectItemId?: number | null;
    /** Order item identifier from storefront. */
    orderLineItemId?: string | null;
    /** Order item index from storefront. */
    orderLineItemIndex?: number | null;
    /** Project output file URL. */
    url?: string | null;
    /** Project output file name. */
    name?: string | null;
    /** Project output file format. */
    format?: string | null;
    /** Output artifact file identifier. */
    artifactId?: string | null;
    /** Project output file access strategy. */
    anonymousAccess?: boolean;
    /** Project output file size in bytes. */
    size?: number | null;
}

/** Dto class, containing description of project processing results. */
export interface ProjectProcessingResultsDto {
    /** Project processing status. */
    status?: ProjectProcessingStatus;
    /** Project status description. */
    statusDescription?: string | null;
    /** Collection of project output file descriptions. */
    outputFileDetails?: ProjectOutputFileDetailsDto[] | null;
}

/** Available value types for order data item. */
export enum OrderDataItemValueType {
    PlainText = "PlainText",
    CommaSeparatedList = "CommaSeparatedList",
    SerializedJson = "SerializedJson",
}

/** Dto class, containing information about project's order data item. */
export interface OrderDataItemDto {
    /** Order data item key (eventuall order metadata field name). */
    key?: string | null;
    /** Order data item value. */
    value?: string | null;
    /** Order data item type. */
    type?: OrderDataItemValueType;
}

/** Storefront types. */
export enum StorefrontType {
    Custom = "Custom",
    ShopifyLegacy = "ShopifyLegacy",
    DocketManager = "DocketManager",
    CustomSaml = "CustomSaml",
    NopCommerce = "NopCommerce",
    WooCommerce = "WooCommerce",
    Magento = "Magento",
    BigCommerce = "BigCommerce",
    Shopify = "Shopify",
    ShopifyCustom = "ShopifyCustom",
}

/** Dto class, containing information about a storefront. */
export interface StorefrontDto {
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
}

/** Paged list of items. */
export interface PagedOfStorefrontDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: StorefrontDto[] | null;
}

/** DTO class, containing infromation about a storefront user. */
export interface StorefrontUserDto {
    /** Storefront user identifier. */
    userId?: string | null;
    /** Storefront tenant indentifier. */
    tenantId?: number;
    /** Storefront identifier. */
    storefrontId?: number | null;
    /** Indicates if the user is tracked as an anonymous. */
    isAnonymous?: boolean;
}

/** Paged list of items. */
export interface PagedOfStorefrontUserDto {
    /** Items count. */
    total?: number;
    /** Items list. */
    items?: StorefrontUserDto[] | null;
}

/** Dto class, containing create operation parameters for storefront user. */
export interface CreateStorefrontUserDto {
    /** Storefront user identifier. */
    storefrontUserId?: string | null;
    /** Indicates if the user is tracked as an anonymous. */
    isAnonymous?: boolean;
}

export interface RegisterStorefrontUserInput {
    /** Storefront user identifier. */
    storefrontUserId?: string | null;
}

/** Dto class, containing parameters for merge anonymous user operation. */
export interface MergeAnonymousUserDataInput {
    /** Anonymous storefront user identifier. */
    anonymousStorefrontUserId?: string | null;
    /** Regular storefront user identifier. */
    regularStorefrontUserId?: string | null;
}

/** Dto class, containing information about tenant applications. */
export interface TenantApplicationsInfoDto {
    /** An url to the 'Design Editor' tenant application. */
    designEditorUrl?: string | null;
    /** An url to the 'UI Framework'. */
    uiFrameworkUrl?: string | null;
    /** An url to the 'Simple editor'. */
    simpleEditorUrl?: string | null;
    /** An url to the 'Workflow Elements' web components library. */
    workflowElementsUrl?: string | null;
    /** An url to the 'Template editor'. */
    templateEditorUrl?: string | null;
    /** An url to the 'Preflight' tenant application. */
    preflightUrl?: string | null;
    /** An url to the 'Dynamic Image' tenant application. */
    dynamicImageUrl?: string | null;
    /** Tenant identifier */
    tenantId?: number;
    /** An ApiKey for the 'Design Editor' tenant application. */
    designEditorApiKey?: string | null;
    /** An ApiKey for the 'Preflight' tenant application. */
    preflightApiKey?: string | null;
    /** An ApiKey for the 'Dynamic Image' tenant application. */
    dynamicImageApiKey?: string | null;
}

/** Dto class, containing general information about tenant. */
export interface TenantInfoDto {
    /** Tenant identifier. */
    tenantId?: number;
    /** Tenancy name. */
    tenancyName?: string | null;
    /** Tenant creation time. */
    tenantCreationTime?: string;
    /** Tenant activeness status. */
    isActive?: boolean;
}

/** Dto class, containing information about size measure unit. */
export interface SizeMeasureUnitDto {
    /** Measure unit full name. */
    name?: string | null;
    /** Measure unit short name. */
    shortName?: string | null;
    /** Measure unit ratio. */
    ratio?: number;
    /** Indicates if measure unit should be used by default. */
    isDefault?: boolean;
}

/** Dto class, containing information about tenant measure units. */
export interface TenantMeasureUnitsInfoDto {
    /** A list of all 'size' measure units of the tenant. */
    sizeMeasureUntis?: SizeMeasureUnitDto[] | null;
}

export interface TenantUserInfoDto {
    /** Tenant identifier. */
    tenantId?: number;
    /** User identifier. */
    userId?: number;
    /** User name. */
    userName?: string | null;
    /** User surname. */
    userSurname?: string | null;
    /** User status. */
    isActive?: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}